module.exports = __webpack_public_path__ + "img/book-copy.10006522.svg";